import { List } from 'immutable';
import _ from 'lodash';

export function ignoreUndefinedMerger(previous, next) {
  if (next === undefined) {
    return previous;
  }
  return next;
}

export function merge(previous, next) {
  return previous.mergeWith(ignoreUndefinedMerger, next);
}

export function mergeExperimental(previous, next) {
  // Should warn if next[key] is not immtuable
  return (new List(Object.keys(next)))
    .reduce(
      (result, key) => result.set(
        key,
        result.get(key) ? result.get(key).mergeWith(ignoreUndefinedMerger, next[key]) : next[key],
      ),
      previous,
    );
}

export function mergeIn(keyPath, previous, next) {
  return previous.setIn(keyPath, mergeExperimental(previous.getIn(keyPath), next));
  // return previous.setIn(keyPath, merge(previous.getIn(keyPath), next));
}

/**
 *
 * @param entityIdentifier
 */
export default entityIdentifier =>
  (entityReducerState, action) => {
    const keyPath = ['payload', 'entities', entityIdentifier];
    if (!_.hasIn(action, keyPath)) {
      return entityReducerState;
    }

    // Makes an assumption that state is a Map or at least ducks like a Map.
    return mergeIn(['entities'], entityReducerState, _.get(action, keyPath));
  };
